export class LocalMemoryCache {
  private cacheStorage: any = {};

  /**
   * Returns the number of key/value pairs currently present in the list associated with the
   * object.
   */
  get length(): number {
    return Object.keys(this.cacheStorage).length;
  }

  /**
   * Empties the list associated with the object of all key/value pairs, if there are any.
   */
  clear(): void {
    this.cacheStorage = {};
  }

  /**
   * value = cacheStorage[key]
   */
  getItem(key: string): string {
    return this.cacheStorage[key] || null;
  }

  /**
   * Returns the name of the nth key in the list, or null if n is greater
   * than or equal to the number of key/value pairs in the object.
   */
  key(index: number): string | null {
    var keys = Object.keys(this.cacheStorage);
    if (index < 0 || index >= keys.length) {
      return null;
    }
    return this.cacheStorage[keys[index]];
  }

  /**
   * delete cacheStorage[key]
   */
  removeItem(key: string): void {
    delete this.cacheStorage[key];
  }

  /**
   * cacheStorage[key] = value
   */
  setItem(key: string, value: string): void {
    this.cacheStorage[key] = value;
  }

  [key: string]: any;
}
